import React from 'react'
import { FacebookIcon, FacebookMessengerIcon, FacebookMessengerShareButton, FacebookShareButton, TelegramIcon, TelegramShareButton, ViberIcon, ViberShareButton, WhatsappIcon, WhatsappShareButton } from 'react-share'

const ShareButton = ({ productName, productID }) => {
  const url = `https://www.thriftstorenepal.com/products/${productID}`
  // const url = `http://localhost:3000/products/${productID}`
  return (
    <div className='d-flex ' style={{
      justifyContent: "space-around",
      marginTop: "1rem",
    }}>
      <FacebookShareButton url={url} quote=" hello" style={{
        boxShadow: "0 0 10px rgba(0,0,0,0.3)",
        borderRadius: "50%",
      }}>
        <FacebookIcon size={40} className='rounded-circle' />
      </FacebookShareButton>

      <FacebookMessengerShareButton url={url} style={{
        boxShadow: "0 0 10px rgba(0,0,0,0.3)",
        borderRadius: "50%",
      }}>
        <FacebookMessengerIcon size={40} className='rounded-circle' />
      </FacebookMessengerShareButton>

      <TelegramShareButton url={url} quote=" hello" style={{
        boxShadow: "0 0 10px rgba(0,0,0,0.3)",
        borderRadius: "50%",
      }}>
        <TelegramIcon size={40} className='rounded-circle' />
      </TelegramShareButton>


      <WhatsappShareButton url={url} style={{
        boxShadow: "0 0 10px rgba(0,0,0,0.3)",
        borderRadius: "50%",
      }}>
        <WhatsappIcon size={40} className='rounded-circle' />
      </WhatsappShareButton>

      <ViberShareButton url={url} style={{
        boxShadow: "0 0 10px rgba(0,0,0,0.3)",
        borderRadius: "50%",
      }}>
        <ViberIcon size={40} className='rounded-circle' />
      </ViberShareButton>
    </div>
  )
}

export default ShareButton


